export const Rick = {
  id: 1,
  name: "Rick Sanchez",
  species: "Human",
  gender: "Male",
  image: "https://rickandmortyapi.com/api/character/avatar/1.jpeg",
};

export const AntennaMorty = {
  id:18,
  name:"Antenna Morty",
  species:"Human",
  gender:"Male",
  origin:{"name":"unknown","url":""},
  image:"https://rickandmortyapi.com/api/character/avatar/18.jpeg",
}

export const BlimBlam = {
  id:50,
  name:"Blim Blam",
  species:"Alien",
  gender:"Male",
  image:"https://rickandmortyapi.com/api/character/avatar/50.jpeg"
}

export const JerryMytholog = {
  id:178,
  name:"Jerry's Mytholog",
  species:"Mythological Creature",
  gender:"Male",
  image:"https://rickandmortyapi.com/api/character/avatar/178.jpeg"
}